module.exports = __webpack_public_path__ + "static/chicago-bridge-18f6be90fcd9bdf5568b5b4a68988493.jpg";